import { Phone, MessageCircle } from 'lucide-react';
import { openTelegramUserDm } from '../../../openTelegramUser';
import { crmTelHref } from './crmPhone';

type Props = {
  phone?: string | null;
  telegramId?: number | null;
  username?: string | null;
  hapticSelection: () => void;
};

export function CrmContactBar({ phone, telegramId, username, hapticSelection }: Props) {
  const telHref = crmTelHref(phone);
  return (
    <div className="flex gap-2 flex-wrap">
      {telHref && (
        <a
          href={telHref}
          onClick={() => hapticSelection()}
          className="press flex-1 min-w-[120px] flex items-center justify-center gap-2 py-3 rounded-xl text-xs font-bold touch-manipulation min-h-[44px]"
          style={{ background: 'rgba(72,187,120,0.15)', color: '#68D391', border: '1px solid rgba(72,187,120,0.35)' }}
        >
          <Phone size={14} /> Позвонить
        </a>
      )}
      {telegramId && (
        <button
          type="button"
          onClick={() => {
            hapticSelection();
            openTelegramUserDm(telegramId, username);
          }}
          className="press flex-1 min-w-[120px] flex items-center justify-center gap-2 py-3 rounded-xl text-xs font-bold touch-manipulation min-h-[44px]"
          style={{ background: 'rgba(99,179,237,0.15)', color: '#63B3ED', border: '1px solid rgba(99,179,237,0.35)' }}
        >
          <MessageCircle size={14} /> Telegram
        </button>
      )}
    </div>
  );
}
